"use strict";

require("core-js/modules/es6.array.map");

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  margin: 0 -5px;\n  > button {\n    text-align: center;\n    min-height: 120px;\n    > span[role='img'] {\n      display: block;\n      font-size: 20px;\n      margin: 0 0 10px 0;\n    }\n    > div {\n      margin: 0 auto 5px auto;\n    }\n    > span {\n      margin-left: 0 !important;\n      max-width: 100%;\n      white-space: normal;\n      line-height: 1.1;\n    }\n    margin: 5px;\n    min-width: 125px;\n    width: 125px;\n    height: 90px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvailableTypeSelector = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("./styledTypes");

var Container = styledTypes_1.styled.div(_templateObject());

function AvailableTypeSelector(_ref) {
  var items = _ref.items,
      onItemSelected = _ref.onItemSelected,
      style = _ref.style,
      buttonStyle = _ref.buttonStyle;
  return react_1["default"].createElement(Container, {
    style: style
  }, items.map(function (item) {
    return react_1["default"].createElement(antd_1.Button, {
      key: item.type,
      onClick: function onClick() {
        return onItemSelected(item.type);
      },
      style: buttonStyle
    }, react_1["default"].createElement(item.icon, null), react_1["default"].createElement("span", null, item.label));
  }));
}

exports.AvailableTypeSelector = AvailableTypeSelector;